export interface PermissionState {
  permissions: readonly string[];
}

export function hasPermission(state: PermissionState, permission: string): boolean {
  return state.permissions.includes(permission);
}

export function hasEveryPermission(
  state: PermissionState,
  permissions: readonly string[],
): boolean {
  return permissions.every((permission) => hasPermission(state, permission));
}

export function hasAnyPermission(state: PermissionState, permissions: readonly string[]): boolean {
  return permissions.some((permission) => hasPermission(state, permission));
}
